var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { createContext, forwardRef, useContext, } from "react";
import { developmentConfig } from "./config/developmentConfig";
import { productionConfig } from "./config/productionConfig";
import { testConfig } from "./config/testConfig";
var uninitializedContextValue = new Proxy({}, {
    get: function () {
        throw new Error("Legoland context is not available. Please use LegolandProvider or LegolandApp component.");
    },
});
var LegolandContext = createContext(uninitializedContextValue);
export var LegolandConsumer = LegolandContext.Consumer;
export function useLegoland() {
    return useContext(LegolandContext);
}
export var LegolandProvider = function (_a) {
    var children = _a.children, _b = _a.environment, environment = _b === void 0 ? "auto" : _b, _c = _a.externalLinkComponent, ExternalLink = _c === void 0 ? "a" : _c, _d = _a.internalLinkComponent, InternalLink = _d === void 0 ? "a" : _d, configFromProps = __rest(_a, ["children", "environment", "externalLinkComponent", "internalLinkComponent"]);
    var config;
    switch (environment) {
        case "auto":
            config =
                process.env.NODE_ENV === "production"
                    ? productionConfig
                    : developmentConfig;
            break;
        case "development":
            config = developmentConfig;
            break;
        case "test":
            config = testConfig;
            break;
        case "production":
            config = productionConfig;
            break;
    }
    var Link = forwardRef(function (props, ref) {
        var href = props.href;
        var Link = !(href === null || href === void 0 ? void 0 : href.startsWith("http")) || (href === null || href === void 0 ? void 0 : href.startsWith(window.location.origin))
            ? InternalLink
            : ExternalLink;
        return React.createElement(Link, __assign({}, props, { ref: ref }));
    });
    var value = __assign(__assign(__assign({}, config), configFromProps), { ExternalLink: ExternalLink, InternalLink: InternalLink, Link: Link });
    return (React.createElement(LegolandContext.Provider, { value: value }, children));
};
//# sourceMappingURL=LegolandContext.js.map